// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoPlayer_wrapper__pJVhT","controlBtn":"VideoPlayer_controlBtn__uSUV3","playing_layer":"VideoPlayer_playing_layer__GVwEU"};